// extracted by mini-css-extract-plugin
export var active = "index-module--active--6d9f6";
export var bodyFont = "index-module--body-font--28ad1";
export var titleFont = "index-module--title-font--cd105";
export var type_selector = "index-module--type_selector--7b2f8";